import { apiClient } from "@/api/apiClient"
import type { ApiResultPromise } from "@/api/errors"

export type SupportChatProvider = "pylon"
export type SupportChatEvent = "resolved" | "failed" | "opened"

// Records an in-app support chat outcome on the backend Prometheus counter so
// real per-provider usage and client-side load failures are chartable in
// Grafana. Fire-and-forget: telemetry must never surface to the user, so a
// failed beacon is returned as a typed error for the caller to log (Sentry)
// without showing UI feedback.
export async function beaconSupportChatEvent(
  provider: SupportChatProvider,
  event: SupportChatEvent,
): ApiResultPromise<void> {
  return apiClient.post<void>(
    "/api/support-chat/events",
    "Failed to beacon support chat event",
    {
      provider,
      event,
    },
  )
}
